// C0 (0x00-0x1F) e DEL (0x7F): barra CR/LF e afins no caminho sem regex de controle (sonar S6324).
function hasControlCharacter(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code <= 0x1f || code === 0x7f) return true;
  }
  return false;
}

/**
 * Aceita apenas caminhos relativos da própria aplicação (iniciados por "/"), rejeitando
 * URLs com esquema/host e caminhos protocol-relative ("//host" ou "/\host").
 */
export function getSafeRedirectPath(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  if (!value.startsWith('/')) return null;
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  if (hasControlCharacter(value)) return null;
  return value;
}
